import { FC, useEffect, useRef, useState } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import './CollapseAbleText.scss'

export function isHTML(content: string): boolean {
  if (content && content.match('</[^>]+>')) {
    return true
  }
  return false
}

const CollapseAbleText: FC<{
  height?: number
  classCustom?: boolean
  text: string
  className?: string
  defaultColapse?: boolean
  inlineButton?: boolean
  buttonStyle?: any
}> = ({ height = 70, text, className, defaultColapse, classCustom, buttonStyle }) => {
  const { translate } = useTranslation()
  const [isHideText, setIsHideText] = useState(!!defaultColapse)
  const [originalHeight, setOriginalHeight] = useState<Number>()
  const elementRef = useRef(null)
  const isCollapsible = originalHeight > height

  useEffect(() => {
    setOriginalHeight(elementRef.current.offsetHeight)
  }, [elementRef, text])

  return (
    <>
      {isHTML(text) ? (
        <div
          ref={elementRef}
          className={` mb-0 w-100 breakable-line ${className ? className : 'slice-text'} ${
            isHideText && isCollapsible ? 'slice-text-hide' : ''
          }`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ) : (
        <p
          ref={elementRef}
          className={` mb-0 w-100 breakable-line ${className ? className : 'slice-text'} ${
            isHideText && isCollapsible ? 'slice-text-hide' : ''
          }`}>
          {text}
        </p>
      )}
      <span>
        {isCollapsible && (
          <>
            {isHideText ? (
              <button
                style={buttonStyle}
                className={`ant-btn btn-view-text ${classCustom ? 'btn-view-p-0' : ''}`}
                onClick={() => setIsHideText(false)}>
                {translate('public_key:view_more')}
              </button>
            ) : (
              <button
                style={buttonStyle}
                className={`ant-btn btn-view-text ${classCustom ? 'btn-view-p-0' : ''}`}
                onClick={() => setIsHideText(true)}>
                {translate('public_key:view_less')}
              </button>
            )}
          </>
        )}
      </span>
    </>
  )
}

export default CollapseAbleText
